import 'antd/dist/antd.css';
import './styles/vars.scss';
import './styles/index.scss';
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { BrowserRouter } from "react-router-dom";
import reportWebVitals from './reportWebVitals';
import { Provider } from "react-redux";
import { store } from "./store/store";
import { Scrollbars } from 'react-custom-scrollbars';

ReactDOM.render(
    <React.StrictMode>
        <Scrollbars style={{ width: "100%", height: '100vh' }} >
            <Provider store={store}>
                <BrowserRouter>
                    <App />
                </BrowserRouter>
            </Provider>
        </Scrollbars>
    </React.StrictMode>,
    document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
